<template>
  <div>
    <div>
      <div class="row" v-if="isOrder">
        <div class="col-lg-3 col-md-4 col-12">
          <div class="form-group">
            <label> From </label>
            <div>
              <Datepicker
                :enableTimePicker="false"
                class="date-time-dashboad"
                v-model="from_date"
                auto-apply
                :format="format"
                :min-date="
                  new Date(new Date().setFullYear(new Date().getFullYear() - 1))
                "
                :max-date="new Date()"
                @update:model-value="onChangeFromDate"
              />
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-4 col-12">
          <div class="form-group">
            <label>
              To
              <span class="text-danger"
                >(Up to {{ totalDaySelect  }} {{ totalDaySelect > 1 ? 'days' : 'day' }})</span
              ></label
            >
            <div>
              <Datepicker
                :enableTimePicker="false"
                class="date-time-dashboad"
                v-model="to_date"
                auto-apply
                :format="format"
                :min-date="from_date"
                :max-date="
                  new Date(
                    new Date(from_date).setDate(
                      new Date(from_date).getDate() + this.totalDaySelect
                    )
                  )
                "
                @update:model-value="onChangeToDate"
              />
            </div>
          </div>
        </div>
        <!-- <div class="col-lg-3 col-md-4 col-12">
          <div class="form-group">
            <label> Status </label>
            <div>
              <Multiselect
                v-model="status"
                :options="statuses"
                placeholder="Select Status"
                @update:model-value="
                  onChangeSearchParameter(status, search_field.STATUS)
                "
              />
            </div>
          </div>
        </div> -->
      </div>
      <div
        :class="{ 'mt-3': isOrder }"
        class="d-flex align-items-center"
        :style="{ 'justify-content': isOrder ? 'end' : 'start' }"
      >
        <div class="search-box-wrapper" style="width: 30%; min-width: 300px">
          <input
            class="nosubmit"
            type="search"
            id="keyword_search"
            v-model="searchKeyword"
            extraClass
            name="keyword_search"
            placeholder="Search item name or item code..."
            @input="onChangesearchKeyword"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import CommonFunctionService from "../../../services/commonFunction.service";
import moment from "moment";
import { SEARCH_FIELD } from "../mock_data";

export default {
  name: "FormSearch",
  components: {
    // Multiselect,
    Datepicker,
  },
  props: {
    onChangeSearchParameter: {
      type: Function,
      required: true,
    },
    totalDaySelect: {
      type: Number,
      default: 7,
    },
    isOrder: {
      type: Boolean,
      default: false,
    },
    defaultFromDate: {
      type: Date,
      default: null,
    },
  },
  data() {
    return {
      statuses: [
        { value: 0, label: "All" },
        { value: -1, label: "Open" },
        { value: 1, label: "Inserted" },
        { value: 2, label: "New" },
        { value: 3, label: "Failed" },
        { value: 4, label: "Timeout" },
      ],
      status: 0,
      from_date: this.defaultFromDate ?? moment(new Date()).subtract(this.totalDaySelect, 'days'),
      to_date: new Date(),
      search_field: SEARCH_FIELD,
      searchKeyword: "",
      searchTimerId: null
    };
  },
  methods: {
    format(date) {
      return CommonFunctionService.formatDateShow(date);
    },

    onChangeFromDate(from_date) {
      this.from_date = from_date;

      if (this.totalDaySelect) {
        let limitDate = moment(from_date).add(this.totalDaySelect, "days");

        if (
          moment(this.to_date) > limitDate ||
          moment(this.to_date) < moment(this.from_date)
        ) {
          if (limitDate > moment()) {
            limitDate = moment();
          }

          this.to_date = limitDate;
          this.onChangeSearchParameter(this.to_date, this.search_field.TO_DATE, false);
        }
      }

      this.onChangeSearchParameter(from_date, this.search_field.FROM_DATE);
    },

    onChangeToDate(to_date) {
      this.to_date = to_date;
      this.onChangeSearchParameter(to_date, this.search_field.TO_DATE);
    },

    onChangesearchKeyword(event) {
      this.searchKeyword = event.target.value;
      clearTimeout(this.searchTimerId);
      this.searchTimerId = setTimeout(() => {
        this.onChangeSearchParameter(this.searchKeyword, this.search_field.SEARCH_KEYWORD);
      }, 1000);
    },
  },
};
</script>

<style scoped>
label:not(.form-check-label):not(.custom-file-label) {
  font-weight: 700;
  color: #212529;
}

input[type="search"] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
}

input[type="search"]::placeholder {
  color: #bbb;
  text-align: left;
  font-weight: normal;
}

input[type="search"]:focus {
  border-color: #72959d;
  outline: none;
  border: none;
  border-bottom: 1px solid #72959d;
}

.nosubmit-parent {
  border: none;
  padding: 0;
}

input.nosubmit {
  border-bottom: 1px solid #d2d2d2;
  width: 100%;
  padding: 9px 4px 9px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}

/* The 300px min-width above overflows viewports narrower than that
   (e.g. small phones), forcing the page to scroll horizontally. */
@media (max-width: 480px) {
  .search-box-wrapper {
    width: 100% !important;
    min-width: 0 !important;
  }
}
</style>
